import React from "react";
import { Input, Space, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import SchedulerScopeChanger from "./SchedulerScopeChanger";
import CalenderTimePicker from "../calender/CalenderTimePicker";
const EventsTopActions = (props) => {
  const {
    newAction,
    onNextDate,
    onPreviousDate,
    currentDate,
    onChangeView,
    calenderView,
  } = props;
  const intl = useIntl();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "10px",
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        {calenderView ? (
          <CalenderTimePicker
            onNextDate={onNextDate}
            onPreviousDate={onPreviousDate}
            currentDate={currentDate}
            calenderView={calenderView}
          />
        ) : (
          <Input
            prefix={
              <SearchOutlined style={{ padding: "0  5px", opacity: 0.4 }} />
            }
            placeholder={intl.formatMessage({
              id: `app.events_schedule.search_for_record`,
            })}
            style={{ width: 300 }}
            size="large"
            allowClear
          />
        )}
      </div>
      <div>
        <Space
          direction="vertical"
          size="small"
          style={{
            display: "flex",
            alignItems: "end",
          }}
        >
          <Button type="primary" onClick={() => newAction(null, "new")}>
            {" "}
            {intl.formatMessage({
              id: `app.events_schedule.new_record`,
            })}
          </Button>
          <div>
            <Space
              size="small"
              style={{
                display: "flex",
              }}
            >
              <SchedulerScopeChanger
                onChangeView={onChangeView}
                calenderView={calenderView}
              />
            </Space>
          </div>
        </Space>
      </div>
    </div>
  );
};
export default EventsTopActions;
